import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import styles from "./bottomsheet.module.css";
import BottomSheetModal from "../../BottomSheetModal";
import exitGameIcon  from "../../../assets/exit-game-icon.svg";
import { handleLeaveGame } from "../../../store/actions/ludoboardActions";

interface LeaveTableBottomsheetInterface {
  isOpen: boolean;
  onClose: () => void;
}

const LeaveTableBottomsheet:React.FC<LeaveTableBottomsheetInterface>= ({ isOpen, onClose}) => {
  const {t}= useTranslation();

  const logoutActions = [
    {
      label: t("no"),
      btnClass: "btn darkBlackBtn",
      onClick: onClose,
    },
    { label: t("yes"),
      btnClass: "btn darkBlackBorderBtn" ,
      onClick: () => {
        handleLeaveGame();
      },
    },
  ];

  return (
    <>
      <BottomSheetModal
        isOpen={isOpen}
        onClose={onClose}
        // modalIcon={exitGameIcon}
        modalContentClassName={clsx(styles.settingModalContent)}
        title={t("leaveGame")}
        content={t("areYouSure")}
        actions={logoutActions}
      />
    </>
  )
}
export default LeaveTableBottomsheet;